/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-shadow */
import {
  CONSULT_ACCEPTED,
  CONSULT_CANCELLED,
  CONSULT_FINISHED,
  CONSULT_PENDING,
  CONSULT_TIMEOUT,
  CONSULT_TYPE_CHAT,
  CONSULT_VIDEO_ENDED,
  POOL_REQUESTS_TAB_ID,
  ROOM_UPDATE_STATUS,
} from 'Constants/consults';
import { MESSAGE_TYPE_ATTACHMENT } from 'Constants/message-types';
import { WEBCHAT } from 'Constants/normalize-module';
import {
  CONSULT_COMMONS_MODEL_RESPONSE,
  CONVERSATION_MODEL_RESPONSE,
  MESSAGES_COUNT_PER_PAGE,
  PRESENCE_ACTION_CONSULT_SERVICE,
  PRESENCE_ACTION_INVITE_DOCTOR,
  PRESENCE_ACTION_SET_MAIN_PROVIDER,
  PRESENCE_ACTION_STATE_CONSULT,
  PRESENCE_ACTION_STATE_READ,
  PRESENCE_ACTION_PATIENT_DECLINE_DOCTOR,
  PRESENCE_ACTION_DOCTOR_ACCEPTED_CONSULT,
  PRESENCE_ACTION_SWITCH_CLINIC_START,
  PRESENCE_ACTION_SWITCH_CLINIC_COMPLETED,
  PRESENCE_ACTION_PRESCRIPTION_STATUS_CHANGED,
} from 'Constants/webchat';
import PubNub from 'Helpers/pubnub';
import { generateIncludeParams } from 'Helpers/utils';
import ContextMenuManager from 'Modules/ContextMenu/ContextMenuManager';
import CustomModal from 'Modules/CustomModal/CustomModal';
import { getDoctorProfile } from 'Redux/modules/doctor/actions';
import { updateEntities } from 'Redux/modules/entities/actions';
import {
  addConversation,
  closeVideo,
  clearConversationActive,
  clearConversationMessageById,
  consultDetails,
  conversationRetrieve,
  doctorConversationsPending,
  getConsultDetailsInPool,
  getConsultsPendingStats,
  getMessagesBackwardByTime,
  messagesReceive,
  removeConversation,
  removePendingConsult,
  selectConsultPending,
  increasePendingConsultStats,
  decreasePendingConsultStats,
  messageRemove,
  getPrivateMessagesBackwardByTime,
  openVideo,
  getConsultsPending,
  getPrescription,
} from 'Redux/modules/webChat/actions';
import {
  bubblesAdd,
  bubblesRemove,
  setActiveClinicTab,
} from 'Redux/modules/webChat/commons/actions';
import {
  initPubnub as actionInitPubnub,
  destroyPubnub as actionDestroyPubnub,
  getPubnubConfig,
  grantToken as grantPubnubToken,
} from 'Redux/modules/webChat/configs/pubnub/actions';
import { conversationActive } from 'Redux/modules/webChat/conversationActive/actions';
import { doctorRetrieve } from 'Redux/modules/webChat/doctor/actions';
import { messageMarkAsRead, setJumpMessage } from 'Redux/modules/webChat/messages/actions';
import {
  denormalizeConversationsByActiveClinic,
  getConsultById,
  getConversationById,
} from 'Selectors/webChat/consults';
import { getMessageByConsult } from 'Selectors/webChat/messages';
import classNames from 'classnames';
import humps from 'humps';
import { arrayOf, func, number, oneOfType, shape, string, any } from 'prop-types';
import React, { PureComponent } from 'react';
import Helmet from 'react-helmet';
import toast from 'react-hot-toast';
import { connect } from 'react-redux';
import { Icon, Portal, Segment, TransitionablePortal } from 'semantic-ui-react';
import { formatDateBodyBE } from 'Helpers/date-utils';
import MainVideoContainer from 'Modules/ZoomContainer/MainVideoContainer';
import ZoomVideo from '@zoom/videosdk';
import { clearToast } from 'Redux/modules/ui/actions';
import { HS_STREAM_MESSAGE } from 'Constants/health-summary';
import { checkIsThisTabPickUpConsult } from 'Helpers/pickUpConsult';
import { getEvaluate } from 'Redux/modules/ai/actions';
import { notification } from 'antd';

import BubbleChat from '../BubbleChat/BubbleChat';
import OfflineCheck from '../OfflineCheck';

import Content from './Content/Content';
import Header from './Header/Header';
import styles from './Main.less';
import Notifications from './Notifications/Notifications';
import Sidebar from './Sidebar/Sidebar';

let localVideoTrack;

const colorToast = {
  info: 'gray',
  success: 'green',
  error: 'red',
};

const iconToast = {
  info: 'info circle',
  success: 'check circle',
  error: 'warning circle',
};

let TIMEOUT_ENDCALL = null;

const KEY_UNREAD_MESSAGE = 'unreadCount';

const CONVERSATION_INCLUDES_PARAM = {
  include: generateIncludeParams(CONVERSATION_MODEL_RESPONSE),
};

const CONSULT_COMMON_PARAMS = {
  include: generateIncludeParams(CONSULT_COMMONS_MODEL_RESPONSE),
};

const updateMessageBodyScroll = () => {
  const body = document.getElementById('message_body');
  if (body) body.scrollTop = body.scrollHeight;
};

const AI_NOTE_MESSAGE_TYPE = 'message';
const AI_CHECKER_MESSAGE_TYPE = 'event';

const MESSAGE_TYPE_SWITCH_CLINIC_COMPLETED = 'switch_clinic_completed';

const ignoreMessage = type =>
  type === 'priority_queue' ||
  type === 'video_call' ||
  type === 'normal_consult' ||
  type === 'consult_service';

let pendingRequestTimer = null;

const FETCH_PENDING_STATS_TIME = 5000;

const FETCH_DOCTOR_PROFILE_TIME = 300000; // 5 mins
class MainLayout extends PureComponent {
  constructor(props) {
    super(props);
    this.zoomClient = null;
    this.closeZoomId = null;
  }

  componentDidMount() {
    this.getInitData();
    this.getDoctorProfile();
    this.interval = setInterval(() => this.getDoctorProfile(), FETCH_DOCTOR_PROFILE_TIME);
    this.zoomClient = ZoomVideo.createClient();
    ZoomVideo.preloadDependentAssets('Global');
    this.zoomClient.init('en-US', 'Global', {
      patchJsMedia: true,
      enforceMultipleVideos: true,
      stayAwake: true,
      leaveOnPageUnload: true,
    });
  }

  componentDidUpdate() {
    const { pubnub, doctor, actionInitPubnub } = this.props;
    if (!pubnub.isInitial && pubnub?.data && doctor && pubnub?.token) {
      actionInitPubnub();
      this.initPubnub(doctor, pubnub?.data, pubnub?.token);
    }
  }

  componentWillUnmount() {
    const { destroyPubnub } = this.props;
    if (PubNub) {
      PubNub.unSubscribe();
      PubNub.clearIntervalAutoGrantToken();
      destroyPubnub();
    }
    clearInterval(this.interval);
    ZoomVideo.destroyClient();
  }

  fetchTotalPendingRequest = () => {
    clearTimeout(pendingRequestTimer);
    const { getConsultsPendingStats } = this.props;
    pendingRequestTimer = setTimeout(() => {
      getConsultsPendingStats();
    }, FETCH_PENDING_STATS_TIME);
  };

  getDoctorProfile = async () => {
    const doctor = await this.props.getDoctorProfile();
    if (doctor && !doctor?.data?.status?.finishedOnboarding) {
      this.props.history.replace('/on-boarding');
    }
  };

  getInitData = () => {
    const { doctorId, doctorRetrieve, getPubnubConfig, grantPubnubToken } = this.props;
    doctorRetrieve(doctorId);
    getPubnubConfig();
    grantPubnubToken();
  };

  // eslint-disable-next-line class-methods-use-this
  emitMessageEvent = message => {
    const event = new CustomEvent(HS_STREAM_MESSAGE, {
      detail: message,
    });
    window.dispatchEvent(event);
  };

  initPubnub = (doctor, pubnub, pubnubToken) => {
    // if (pubnub?.data && doctor) {
    this.props.actionInitPubnub();
    PubNub.init({
      channelId: doctor.userUuid,
      publishKey: pubnub.publishKey,
      subscribeKey: pubnub.subscribeKey,
      authKey: doctor.authKey,
      token: pubnubToken,
    });
    PubNub.subscribe(this.receiveMessage);
    // }
  };

  fetchMessage = (conversationId, isReplace = false, isPrivateChat = false) => {
    const params = { conversationId, count: MESSAGES_COUNT_PER_PAGE, timestamp: Date.now() };
    if (isPrivateChat) {
      this.props.getPrivateMessagesBackwardByTime(params, isReplace);
    } else {
      this.props.getMessagesBackwardByTime(params, isReplace);
    }
  };

  updateConversation = message => {
    const { updateEntities, conversationActiveId, focusedChat, listConversation, activeTab } =
      this.props;
    const {
      message: { text, media, attachment },
      sentAt,
      metadata: { conversationId },
    } = message;

    let latestMessage = text;
    if (media) {
      latestMessage = 'You have a media';
    } else if (attachment) {
      latestMessage = attachment.body;
    }

    // update unread count message
    const conversation = listConversation?.find(
      item =>
        item.id === conversationId || item?.latestConsult?.doctorConversationId === conversationId,
    );
    const isPrivateConsult = listConversation?.find(
      item => item?.latestConsult?.doctorConversationId === conversationId,
    );
    const mainConversationId = conversation?.id;
    if (conversation) {
      // const conversation = getConversationById(mainConversationId);
      const conversationData = {
        ...conversation,
        latestConsult: conversation?.latestConsult?.id,
        participant: {
          latestTime: formatDateBodyBE(sentAt),
        },
      };
      if (
        conversation?.latestConsult?.doctorConversation &&
        mainConversationId === activeTab?.groupId
      ) {
        if (activeTab?.tab !== 2 && isPrivateConsult) {
          updateEntities(WEBCHAT, 'consult', conversation?.latestConsult?.id, {
            doctorConversation: {
              participant: {
                unreadCount:
                  conversation?.latestConsult?.doctorConversation.participant[KEY_UNREAD_MESSAGE] +
                  1,
              },
            },
          });
        } else if (!isPrivateConsult && activeTab?.tab !== 1) {
          conversationData.participant[KEY_UNREAD_MESSAGE] =
            conversation?.participant[KEY_UNREAD_MESSAGE] + 1;
        }
      } else if (mainConversationId !== conversationActiveId) {
        conversationData.participant[KEY_UNREAD_MESSAGE] =
          conversation.participant[KEY_UNREAD_MESSAGE] + 1;
      }
      if (mainConversationId === focusedChat && !isPrivateConsult) {
        conversationData.participant[KEY_UNREAD_MESSAGE] = 0;
        // scroll to new message
        updateMessageBodyScroll();
      }
      if (!isPrivateConsult && latestMessage) {
        conversationData.participant.latestMessage = latestMessage;
      }
      updateEntities(WEBCHAT, 'conversation', mainConversationId, conversationData);
    }
  };

  receiveMessage = async data => {
    const {
      messagesReceive,
      focusedChat,
      setJumpMessage,
      getConversationById,
      conversationRetrieve,
      updateEntities,
      removeMessage,
      getEvaluate,
    } = this.props;
    const newData = humps.camelizeKeys(data);
    console.log('🚀 ~ MainLayout ~ newData:', newData);

    if (newData.message.type === AI_CHECKER_MESSAGE_TYPE) {
      const evaluationId = newData.message?.metadata?.evaluationId;
      if (evaluationId) {
        getEvaluate(evaluationId);
      }
      return;
    }

    if (newData.message.type === AI_NOTE_MESSAGE_TYPE) {
      this.emitMessageEvent(newData.message);
      return;
    }
    setJumpMessage(null);
    if (newData.message?.isDeleted) {
      removeMessage(newData.message);
      return;
    }
    if (data.message.action) {
      this.receivePresenceMessage(data);
    }
    if (newData.message && !data.message.action) {
      const { message } = newData;
      const { type, metadata } = message;

      if (ignoreMessage(type)) return;

      const isSwitchConsultCompleted = type === MESSAGE_TYPE_SWITCH_CLINIC_COMPLETED;

      if (isSwitchConsultCompleted) {
        notification.open({
          message: (
            <span style={{ fontWeight: 600, fontSize: '16px' }}>Switching Clinic Completed</span>
          ),
          description: message?.message?.text,
          placement: 'bottomLeft',
          icon: <Icon name="check circle" color="green" />,
        });
      }

      const isBotIssue =
        type === MESSAGE_TYPE_ATTACHMENT &&
        message?.message?.attachment?.id === 'issue.patient.create';

      if (isBotIssue) {
        const latestIssue = { botMessage: message?.message?.attachment?.body };
        updateEntities(WEBCHAT, 'consult', metadata?.consultId, { latestIssue });
      }

      const conversation = getConversationById(metadata?.conversationId);
      if (!conversation && !!metadata?.conversationId) {
        await conversationRetrieve(metadata?.conversationId, CONVERSATION_INCLUDES_PARAM);
      }
      messagesReceive(message, metadata?.conversationId);
      // ignore private consult to latest consult
      this.updateConversation(message);

      // scroll bottom when active chat.
      const body = focusedChat
        ? document.getElementById(`message_body_${focusedChat}`)
        : document.getElementById('message_body');
      if (body) body.scrollTop = body.scrollHeight;
    }
  };

  handleInvite2ndDoctor = async message => {
    const {
      doctorId,
      conversationActiveId,
      bubbles,
      bubblesAdd,
      bubblesRemove,
      getConversationById,
      conversationRetrieve,
      activeClinicTab,
      conversationActive,
      removeConversation,
    } = this.props;
    const {
      metadata: { conversationId, invitation },
    } = message;

    // get new conversation data
    const newConversationData = await conversationRetrieve(
      invitation?.conversationId,
      CONVERSATION_INCLUDES_PARAM,
    );
    const newConversation = newConversationData?.data;
    if (!newConversation) return;

    // check clinic of current doctor
    const clinics = newConversation.latestConsult?.clinics || [];
    const workingClinicId = clinics.find(item => item.doctorId === +doctorId)?.clinicId;

    // if current clinic tab is not the same as the clinicIds in conversation detail of this doctor, just handle nothing
    if (activeClinicTab !== workingClinicId) return;

    // reload msg of old conversation for inviting doctor
    if (+doctorId === invitation?.fromDoctorId) {
      if (conversationId !== invitation?.conversationId) {
        removeConversation(conversationId, workingClinicId);
      }
    }

    // add to correct clinic tab
    this.refreshConversation(invitation?.conversationId, workingClinicId);

    const isActiveConversation = conversationActiveId === conversationId;
    const isActiveBubbleConversation = bubbles?.find(item => item.id === conversationId);

    // reload msg if conversation active or bubble chat
    if (isActiveConversation || isActiveBubbleConversation) {
      if (invitation?.conversationId) {
        this.fetchMessage(invitation?.conversationId);
      }
    }

    // redirect to invite conversation when active conversation
    if (isActiveConversation) {
      conversationActive(invitation?.conversationId);
    }

    // reload bubble chat
    if (isActiveBubbleConversation) {
      bubblesRemove(conversationId);
      const conversation = getConversationById(invitation?.conversationId);
      if (!conversation) {
        bubblesAdd(newConversation);
      } else {
        bubblesAdd(conversation);
      }
    }
  };

  receivePresenceMessage = async data => {
    const {
      doctorId,
      sessionId,
      conversationActiveId,
      doctorConversationsPending,
      messageMarkAsRead,
      updateEntities,
      video,
      getConsultById,
      openVideo,
      pendingConsultActive,
      bubbles,
      conversationActive,
      selectConsultPending,
      removePendingConsult,
      getConsultDetailsInPool,
      increasePendingConsultStats,
      decreasePendingConsultStats,
      activeClinicTab,
      setActiveClinicTab,
      conversationRetrieve,
      addConversation,
      removeConversation,
      history,
      prescriptionDetail,
      getPrescription,
    } = this.props;
    const newData = humps.camelizeKeys(data);
    const { message } = newData;
    const { metadata, action } = message;
    const consult = getConsultById(metadata.consultId);

    switch (action) {
      case PRESENCE_ACTION_SET_MAIN_PROVIDER: {
        const { doctorConversationId } = consult;
        const { conversationId } = message.metadata;
        this.refreshConversation(conversationId, activeClinicTab);
        this.fetchMessage(conversationId, true);
        this.fetchMessage(doctorConversationId, true, true);
        break;
      }
      case PRESENCE_ACTION_STATE_CONSULT: {
        const { conversationId, status, consultId, doctorDeviceId, clinicId } = message.metadata;

        if (status !== CONSULT_FINISHED) {
          // fetch pending consult number by doctor
          doctorConversationsPending({ doctorId });
          await this.refreshConversation(conversationId, clinicId);
        } else {
          conversationRetrieve(conversationId, CONVERSATION_INCLUDES_PARAM);
        }

        if (status === CONSULT_PENDING) {
          this.fetchMessage(conversationId);
        }

        if (status === CONSULT_ACCEPTED) {
          // CASE 1: Doctor is in a clinic tab => just update conversation list
          if (activeClinicTab !== POOL_REQUESTS_TAB_ID) {
            if (conversationId !== conversationActiveId) {
              // refetch message when start follow up in invite conversation
              this.fetchMessage(conversationId, true);
            }
            this.fetchTotalPendingRequest();
            return;
          }

          // CASE 2: Doctor is in tab Pending request
          // CASE 2A: The current pending consult is not the consultId in event
          // => just remove it from list
          if (pendingConsultActive !== consultId) {
            removePendingConsult(consultId);
            decreasePendingConsultStats(1);
            this.fetchTotalPendingRequest();
            return;
          }

          // CASE 2B: The current pending consult is the same as the consultId in event
          // => update conversation list, auto call,...

          selectConsultPending(-1);

          // close bubble chat
          if (!bubbles.find(bubble => bubble?.id === conversationId)) {
            conversationActive(conversationId, false);
          }

          await this.fetchMessage(conversationId, true);

          // jump to the clinic tab which this request belongs to
          setActiveClinicTab(clinicId);
          history.replace(`/web-chat/${clinicId}`, {}, { shallow: true });

          // read message
          await messageMarkAsRead({
            action: 'read',
            user: '',
            metadata: {
              consultId,
              conversationId,
              consultType: CONSULT_TYPE_CHAT,
            },
          });
          await updateEntities(WEBCHAT, 'conversation', conversationId, {
            participant: {
              unreadCount: 0,
            },
          });

          // scroll to last
          const body = document.getElementById('message_body');
          if (body) body.scrollTop = body.scrollHeight;

          // auto start video call when
          // 1. The consult is video call required
          // 2. This device click Accept (distinguish between Web and Mobile, between browsers, between profiles)
          // 3. This tab click Accept (distinguish between tabs)
          if (
            consult?.service?.isVideoCallRequired &&
            sessionId === doctorDeviceId &&
            checkIsThisTabPickUpConsult(consultId, doctorId)
          ) {
            openVideo(consultId, conversationId, consult.patient);
          }
          this.fetchTotalPendingRequest();
        }
        break;
      }
      case PRESENCE_ACTION_STATE_READ: {
        this.updateReadMessage(message);
        break;
      }
      case PRESENCE_ACTION_INVITE_DOCTOR: {
        this.handleInvite2ndDoctor(message);
        break;
      }
      case PRESENCE_ACTION_CONSULT_SERVICE: {
        this.updatePoolConsult(metadata, action);
        break;
      }
      case ROOM_UPDATE_STATUS: {
        let meta = metadata;
        if (typeof metadata === 'string') {
          meta = humps.camelizeKeys(JSON.parse(metadata));
        }
        if (meta.status === CONSULT_VIDEO_ENDED && meta.roomId === video?.zoomInfo?.id) {
          this.closeZoomId = meta.roomId;
          this.endVideoCall();
        }
        break;
      }

      // If current doctor accepted => just update status
      // If other doctors received this event => remove from list
      case PRESENCE_ACTION_DOCTOR_ACCEPTED_CONSULT: {
        if (activeClinicTab === POOL_REQUESTS_TAB_ID) {
          const { consultId, doctorId: doctorIdMessage } = metadata;

          if (+doctorId === doctorIdMessage) {
            getConsultDetailsInPool(consultId, CONSULT_COMMON_PARAMS);
          } else {
            if (consultId === pendingConsultActive) selectConsultPending(-1);
            removePendingConsult(consultId);
            decreasePendingConsultStats(1);
          }
        }

        this.fetchTotalPendingRequest();

        break;
      }

      // If current doctor is declined => remove UI, remove item from list
      // If other doctors received this event => add to list
      case PRESENCE_ACTION_PATIENT_DECLINE_DOCTOR: {
        if (activeClinicTab === POOL_REQUESTS_TAB_ID) {
          const { consultId, declinedDoctorIds } = metadata;

          if ((declinedDoctorIds || []).includes(+doctorId)) {
            if (consultId === pendingConsultActive) selectConsultPending(-1);
            removePendingConsult(consultId);
            decreasePendingConsultStats(1);
          } else {
            getConsultDetailsInPool(consultId, CONSULT_COMMON_PARAMS);
            increasePendingConsultStats(1);
          }
        }

        this.fetchTotalPendingRequest();

        break;
      }

      case PRESENCE_ACTION_SWITCH_CLINIC_START: {
        const { metadata } = message;
        const {
          oldConversationId,
          newConversationId,
          oldClinicId,
          newClinicId,
          doctorId: doctorIdMessage,
        } = metadata;

        if (+doctorId === doctorIdMessage) {
          // Update new conversation detail, message, new clinic list
          const newConversationRes = await conversationRetrieve(
            newConversationId,
            CONVERSATION_INCLUDES_PARAM,
          );

          const newConversation = newConversationRes?.data;
          await addConversation(newConversation?.id, newClinicId);
          await conversationActive(newConversation?.id);

          // jump to new clinic
          setActiveClinicTab(newClinicId);

          // Update old conversation detail, message, old clinic list
          // Check in store first, if multi doctors => remove old conversation from old clinic immediately
          let oldConversation = getConversationById(oldConversationId);
          if (oldConversation?.latestConsult?.doctorConversationId) {
            removeConversation(oldConversationId, oldClinicId);
          } else {
            const oldConversationRes = await conversationRetrieve(
              oldConversationId,
              CONVERSATION_INCLUDES_PARAM,
            );

            oldConversation = oldConversationRes?.data;

            if (
              !oldConversation?.latestConsult ||
              !!oldConversation?.latestConsult?.doctorConversationId
            ) {
              // If old conversation latest consult now is null or conversation is multi doctors
              // => Remove old conversation from old clinic
              removeConversation(oldConversationId, oldClinicId);
            } else {
              // Add old conversation to old clinic
              addConversation(oldConversationId, oldClinicId);

              // Fetch message of old conversation
              this.fetchMessage(oldConversationId, true);
            }
          }
        }

        break;
      }

      case PRESENCE_ACTION_SWITCH_CLINIC_COMPLETED: {
        const { newConversationId } = metadata;

        // Update conversation detail
        const newConversationRes = await conversationRetrieve(
          newConversationId,
          CONVERSATION_INCLUDES_PARAM,
        );

        // Fetch message of new conversation
        this.fetchMessage(newConversationId, true);

        const newConversation = newConversationRes?.data;
        const privateConversationId = newConversation?.latestConsult?.doctorConversationId;

        // Fetch message of private conversation of new conversation
        if (privateConversationId) {
          this.fetchMessage(privateConversationId, true, true);
        }

        break;
      }

      case PRESENCE_ACTION_PRESCRIPTION_STATUS_CHANGED: {
        const { id: prescriptionIdInMessage } = metadata;

        // If the same -> trigger reload prescription detail
        if (prescriptionIdInMessage === prescriptionDetail?.id) {
          getPrescription(prescriptionIdInMessage);
        }

        break;
      }

      default:
        break;
    }
  };

  endVideoCall = () => {
    const { video } = this.props;
    const joiningElement = document.getElementById('joining-video-call');
    if (!document.body.contains(joiningElement)) {
      if (this.closeZoomId === video?.zoomInfo?.id) {
        this.props.closeVideo();
      }
      clearTimeout(TIMEOUT_ENDCALL);
    } else {
      TIMEOUT_ENDCALL = setTimeout(() => {
        this.endVideoCall();
      }, 1000);
    }
  };

  updateReadMessage = state => {
    const {
      updateEntities,
      doctor: { userUuid },
    } = this.props;
    let { metadata } = state;
    if (metadata) {
      if (typeof metadata === 'string') {
        metadata = humps.camelizeKeys(JSON.parse(metadata));
      }
      const { consultId, consultType } = metadata;
      if (state.user === userUuid && consultType === CONSULT_TYPE_CHAT) {
        const latestConsult = {
          [KEY_UNREAD_MESSAGE]: 0,
        };
        updateEntities(WEBCHAT, 'consult', consultId, latestConsult);
      }
    }
  };

  // get conversation details and add to clinic tab
  refreshConversation = async (conversationId, clinicId) => {
    const { addConversation, conversationRetrieve } = this.props;
    await conversationRetrieve(conversationId, CONVERSATION_INCLUDES_PARAM);
    addConversation(conversationId, clinicId);
  };

  updatePoolConsult = metadata => {
    const {
      getConsultDetailsInPool,
      removePendingConsult,
      selectConsultPending,
      pendingConsultActive,
      doctorId,
      activeClinicTab,
      location,
    } = this.props;
    const { consultId, status, consultType, doctorId: doctorIdMessage } = metadata;

    if (
      consultType === CONSULT_TYPE_CHAT &&
      !!location?.pathname &&
      location?.pathname?.includes('/web-chat')
    ) {
      this.fetchTotalPendingRequest();
      switch (status) {
        case CONSULT_PENDING: {
          if (activeClinicTab === POOL_REQUESTS_TAB_ID) {
            getConsultDetailsInPool(consultId, CONSULT_COMMON_PARAMS);
          }
          break;
        }
        case CONSULT_CANCELLED:
        case CONSULT_TIMEOUT:
        case CONSULT_ACCEPTED:
          removePendingConsult(consultId);
          if (consultId === pendingConsultActive && +doctorId !== +doctorIdMessage) {
            toast.error('This consult has been cancelled or timeout');
          }
          if (consultId === pendingConsultActive) {
            // remove pending consult active if it's cancelled or timeout or accepted
            selectConsultPending(-1);
          }
          break;
        default:
          break;
      }
    }
  };

  render() {
    const { bodyClass, videoConsultId, clearToastFunc, uiToast } = this.props;
    const bodyClassName = classNames(styles.layout, bodyClass);

    return (
      <div className="manadr application" id="application" style={{ transition: 'all 0.2s' }}>
        <Helmet>
          <body className={bodyClassName} />
        </Helmet>
        <Header />
        <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
          <Sidebar />
          <Content />
          <BubbleChat />
          <Notifications />
          <OfflineCheck toast={toast} />
        </div>
        <ContextMenuManager />
        {videoConsultId && (
          <Portal open closeOnDocumentClick={false}>
            <MainVideoContainer
              localVideoTrack={localVideoTrack}
              consultId={videoConsultId}
              zoomClient={this.zoomClient}
            />
          </Portal>
        )}
        {uiToast && (
          <TransitionablePortal
            open={uiToast}
            transition={{ animation: 'fly up' }}
            onClose={clearToastFunc}>
            <Segment
              style={{
                left: '24px',
                position: 'fixed',
                bottom: '24px',
                zIndex: 1000,
              }}>
              <p style={{ color: colorToast[uiToast.type] }}>
                <Icon name={iconToast[uiToast.type]} color={colorToast[uiToast.type]} />
                {uiToast.message}
              </p>
            </Segment>
          </TransitionablePortal>
        )}
        <CustomModal />
      </div>
    );
  }
}

MainLayout.propTypes = {
  bodyClass: string,
  doctor: shape({}),
  videoConsultId: number,
  doctorId: oneOfType([string, number]).isRequired,
  pubnub: shape({}).isRequired,
  history: shape({}).isRequired,
  actionInitPubnub: func.isRequired,
  getConversationById: func.isRequired,
  updateEntities: func.isRequired,
  doctorRetrieve: func.isRequired,
  doctorConversationsPending: func.isRequired,
  getConsultsPendingStats: func.isRequired,
  addConversation: func.isRequired,
  getPubnubConfig: func.isRequired,
  messagesReceive: func.isRequired,
  conversationActiveId: number.isRequired,
  getDoctorProfile: func.isRequired,
  conversationRetrieve: func.isRequired,
  removePendingConsult: func.isRequired,
  getConsultDetailsInPool: func.isRequired,
  selectConsultPending: func.isRequired,
  setJumpMessage: func.isRequired,
  getMessagesBackwardByTime: func.isRequired,
  getPrivateMessagesBackwardByTime: func.isRequired,
  conversationActive: func.isRequired,
  bubblesAdd: func.isRequired,
  bubblesRemove: func.isRequired,
  destroyPubnub: func.isRequired,
  messageMarkAsRead: func.isRequired,
  removeMessage: func.isRequired,
  focusedChat: oneOfType([string, number]),
  activeTab: any,
  pendingConsultActive: oneOfType([string, number]).isRequired,
  bubbles: arrayOf(string),
  listConversation: arrayOf(shape({})),
  closeVideo: func.isRequired,
  clearToastFunc: func.isRequired,
  location: shape({}).isRequired,
  activeClinicTab: oneOfType([number, string]).isRequired,
  getPrescription: func.isRequired,
};

MainLayout.defaultProps = {
  bodyClass: '',
  doctor: null,
  focusedChat: null,
  videoConsultId: null,
  activeTab: null,
  bubbles: [],
  listConversation: [],
};

export default connect(
  state => ({
    bubbles: state.webChat.commons.bubbles,
    doctor: state.webChat.doctor.data,
    focusedChat: state.webChat.commons.focusedChat,
    activeTab: state.webChat.commons.activeTab,
    doctorId: state.auth.data.accountId,
    sessionId: state.auth.data.sessionId,
    conversationActiveId: state.webChat.conversationActive,
    getMessageByConsult: id => getMessageByConsult(state, id),
    getConsultById: id => getConsultById(state, id),
    getConversationById: id => getConversationById(state, id),
    listConversation: denormalizeConversationsByActiveClinic(state),
    videoConsultId: state.webChat.video.videoConsultId,
    video: state.webChat.video,
    pubnub: state.webChat.configs.pubnub,
    pendingConsultActive: state.webChat.consults.pendingConsultActive,
    activeClinicTab: state.webChat.commons.activeClinicTab,
    uiToast: state.ui.toast,
    prescriptionDetail: state.webChat.prescription.data,
  }),
  {
    doctorRetrieve,
    getPubnubConfig,
    getDoctorProfile,
    messagesReceive,
    closeVideo,
    openVideo,
    updateEntities,
    conversationRetrieve,
    addConversation,
    removeConversation,
    removePendingConsult,
    increasePendingConsultStats,
    decreasePendingConsultStats,
    getConsultDetailsInPool,
    getMessagesBackwardByTime,
    getPrivateMessagesBackwardByTime,
    setJumpMessage,
    clearConversationMessageById,
    clearConversationActive,
    selectConsultPending,
    conversationActive,
    bubblesAdd,
    bubblesRemove,
    doctorConversationsPending,
    actionInitPubnub,
    getConsultsPendingStats,
    getConsultDetails: consultDetails,
    destroyPubnub: actionDestroyPubnub,
    messageMarkAsRead,
    removeMessage: messageRemove,
    clearToastFunc: clearToast,
    grantPubnubToken,
    getConsultsPending,
    setActiveClinicTab,
    getEvaluate,
    getPrescription,
  },
)(MainLayout);
